import { render, staticRenderFns } from "./TopluGenelTalepGonderIslemDetayView.vue?vue&type=template&id=68ab90ac&scoped=true"
import script from "./TopluGenelTalepGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TopluGenelTalepGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ab90ac",
  null
  
)

export default component.exports